import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';

import { HttpErrorDialogInterceptor } from '@app/core/services/interceptors/http-error-dialog-interceptor.service';
import { environment } from '@env/environment';
import { AccountsAPI } from './api/accounts.service';
import { CommonAPI } from './api/common.service';
import { KeyFiguresAPI } from './api/key-figures-api.service';
import { MonitorAPI } from './api/monitor.service';
import { PGAPIService } from './api/pg-api.service';
import { ProductsAPI } from './api/products.service';
import { ScenariosAPI } from './api/scenarios.service';
import { SignupService } from './api/signup.service';
import { UsersAPI } from './api/users.service';
import { GlobalErrorHandler } from './services/error-handler.service';
import { LoggingService } from './services/error-logging.service';
import { GlobalSideNavService } from './services/global-side-nav.service';
import { HttpAuthInterceptor } from './services/interceptors/http-auth-interceptor.service';
import { HttpCacheInterceptor } from './services/interceptors/http-cache.interceptor';
import { HttpErrorTransformInterceptor } from './services/interceptors/http-error-transform-interceptor.service';
import { HttpSessionTimeoutInterceptor } from './services/interceptors/http-session-timeout.interceptor';
import { LayoutService } from './services/layout.service';
import { StateService } from './services/state.service';
import { TourService } from './services/tour.service';
import { UnsavedFormGuard } from './services/unsaved-form-guard.service';
import { UnsavedModalAlertService } from './services/unsaved-modal-alert.service';
import { UtilitiesService } from './services/utilities.service';
import { StoreModule } from './store/store.module';

const DEV_ONLY_PROVIDERS =
  !environment.production && !!localStorage.getItem('useCache')
    ? [{ provide: HTTP_INTERCEPTORS, useClass: HttpCacheInterceptor, multi: true }]
    : [];

@NgModule({
  imports: [StoreModule],
  providers: [
    ...DEV_ONLY_PROVIDERS,
    { provide: HTTP_INTERCEPTORS, useClass: HttpAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorTransformInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorDialogInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpSessionTimeoutInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    LoggingService,
    UtilitiesService,
    StateService,
    LayoutService,
    GlobalSideNavService,
    UnsavedModalAlertService,
    TourService,
    CommonAPI,
    AccountsAPI,
    ProductsAPI,
    KeyFiguresAPI,
    ScenariosAPI,
    UsersAPI,
    SignupService,
    MonitorAPI,
    PGAPIService,
    UnsavedFormGuard,
  ],
})
export class CoreModule {}
